var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPattenInformation(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 768,
    height: 155,
    viewBox: "0 0 768 155",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_501_25292)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M740.891 149.677L725.854 123.605L740.891 97.5319L770.964 97.5319L786.139 123.605L770.964 149.677L740.891 149.677Z",
    stroke: "#FF6B00",
    strokeWidth: 1.37951,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M740.891 84.2888L725.854 58.216L740.891 32.1432L770.964 32.1432L786.139 58.216L770.964 84.2888L740.891 84.2888Z",
    stroke: "#FF6B00",
    strokeWidth: 1.37951,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M571.904 98.1458L556.867 72.0729L571.904 46.0002L601.977 46.0002L617.152 72.073L601.977 98.1458L571.904 98.1458Z",
    stroke: "#FF6B00",
    strokeWidth: 1.37951,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M504.904 124.146L489.867 98.073L504.904 72.0002L534.977 72.0002L550.152 98.073L534.977 124.146L504.904 124.146Z",
    stroke: "#FF6B00",
    strokeWidth: 1.37951,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M659.904 22.1458L644.867 -3.92705L659.904 -29.9998L689.977 -29.9998L705.152 -3.92704L689.977 22.1458L659.904 22.1458Z",
    stroke: "#FF6B00",
    strokeWidth: 1.37951,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M463.903 22.1458L448.867 -3.92705L463.903 -29.9998L493.977 -29.9998L509.151 -3.92704L493.977 22.1458L463.903 22.1458Z",
    stroke: "#FF6B00",
    strokeWidth: 1.37951,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M419.637 105.941L404.601 79.8686L419.637 53.7958L449.711 53.7958L464.885 79.8686L449.711 105.941L419.637 105.941Z",
    stroke: "#FF6B00",
    strokeWidth: 1.37951,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M320.037 116.288L305 90.2153L320.037 64.1425L350.248 64.1425L365.285 90.2153L350.248 116.288L320.037 116.288Z",
    stroke: "#FF6B00",
    strokeWidth: 1.37951,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M177.037 74.1455L162 48.0727L177.037 21.9999L207.248 21.9999L222.285 48.0727L207.248 74.1455L177.037 74.1455Z",
    stroke: "#FF6B00",
    strokeWidth: 1.37951,
    strokeMiterlimit: 10
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_501_25292"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 768,
    height: 155,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPattenInformation);
export default __webpack_public_path__ + "static/media/patten-information.040bc460f9bebcfc915b93e1068a9b2d.svg";
export { ForwardRef as ReactComponent };